import { FC } from 'react';

export const BlotterErrorIcon: FC<{ message: string }> = ({ message }) => {
  return (
    <div className="m-1" role="status">
      <span className="text-danger">
        <i className="icon icon-sm" title={message}>
          error
        </i>
        <span className="visually-hidden">{message}</span>
      </span>
    </div>
  );
};

BlotterErrorIcon.displayName = 'BlotterErrorIcon';
